import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LockOpen from '@material-ui/icons/LockOpen';
import CreditCard from '@material-ui/icons/CreditCard';
import PinDrop from '@material-ui/icons/PinDrop';
import BikeIcon from '../Icon/BikeIcon';
import { RENTERS } from '../../constants/routes';
import { siteIsActivated } from '../../services/SiteService';

const styles = () => (
  {
   content: {
      flex: '1 0 auto',
      paddingBottom: '20px',
      paddingTop: '20px',
      fontSize: '2em',
    },
  }
);

const activeCountIndicator = (count) => {
  return `(${count} ${count > 1 ? 'actifs' : 'actif'})`
}

const DashboardRenterBlock = ({
  classes,
  name,
  bikes,
  sites,
  total_turnover,
  rent_count,
  id,
  key,
}) => {
  bikes.forEach((b) => {
    const bikeSite = sites.find((s) => s.id === b.site_id);
    if (bikeSite !== undefined && bikeSite !== null) {
      b.siteActivated = siteIsActivated(bikeSite);
    }
  });
  const bikesOnActivatedSite = bikes.filter((b) => b.siteActivated);
  const countActivatedBikesOnActivatedSite = bikesOnActivatedSite.filter((b) =>
    b.is_activate
  ).length;
  const bikesOnDisabledSite = bikes.filter((b) => !b.siteActivated);
  const countActivatedBikesOnDisabledSite = bikesOnDisabledSite.filter((b) =>
    b.is_activate
  ).length;

  return (
    <Grid item xs={12} sm={12} md={6} lg={3} className={classes.gridItem}>
      <Link to={`${RENTERS}/${id}`}>
        <Card key={key}>
          <CardContent className={classes.content}>
            <Typography variant="h5" component="h2">
              {name}
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <PinDrop />
                </ListItemIcon>
                <ListItemText
                  primary={`Site : ${sites.length || 0}`}
                />
              </ListItem>
              <ListItem style={{ alignItems: 'flex-start' }}>
                <ListItemIcon>
                  <BikeIcon />
                </ListItemIcon>
                <Grid container style={{ flexDirection: 'column' }}>
                  <ListItemText
                    primary={
                    `Vélos sur stations actives : ${bikesOnActivatedSite.length} ${activeCountIndicator(countActivatedBikesOnActivatedSite)}`
                  }
                  />
                  <ListItemText
                    primary={
                    `Vélos sur stations inactives : ${bikesOnDisabledSite.length} ${activeCountIndicator(countActivatedBikesOnDisabledSite)}`
                  }
                  />
                </Grid>
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <CreditCard />
                </ListItemIcon>
                <ListItemText
                  primary={`Chiffre d'affaire : ${(total_turnover || 0) / 100} €`}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <LockOpen />
                </ListItemIcon>
                <ListItemText
                  primary={`Locations : ${rent_count || 0}`}
                />
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Link>
    </Grid>
  );
};

DashboardRenterBlock.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DashboardRenterBlock);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardRenterBlock.jsx